import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    setEditedEvent,
    setModalViewActualTab,
    setAddEventMode,
    setDuplicatedEventId,
    setEditModalMode,
    toggleAddModal,
    toggleEditModal,
    toggleNeedRefresh,
    clearDuplicatedEventId
} from '../../store/eventsSlice';
import { setSelectedEvent } from '../../store/statsSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';
import { showAlert } from '../../components/components/global_alert/alertBus';
import EventPromotionBadge from './EventPromotionBadge.jsx';
import { fetchActiveAndScheduledPromotions, getPromotionForEvent } from './eventPromotionLookup.js';
import './Events.css';
import './ModalX.css';
import './Stepper.css';

const previewTabs = ["Dane podstawowe", "Opis", "Multimedia"];
const editTabs = ["Dane podstawowe", "Opis"];
const addTabs = ["Dane podstawowe", "Opis"];
const TAGS_HELPER_TEXT = "Dodaj słowa kluczowe opisujące wydarzenie. Tagi pomagają użytkownikom łatwiej znaleźć Twoje wydarzenie podczas wyszukiwania treści w aplikacji.";

function AddEvent() {
    const dispatch = useDispatch();

    const addEventMode = useSelector((state) => state.events.addEventMode);

    const editedEvent = useSelector((state) => state.events.editedEvent);
    const visibleEventIds = useSelector((state) => state.events.visibleEventIds);
    const duplicatedEventId = useSelector((state) => state.events.duplicatedEventId);
    const isAddModalOpen = useSelector((state) => state.events.addModalOpen);
    const isEditModalOpen = useSelector((state) => state.events.editModalOpen);
    const editModalMode = useSelector((state) => state.events.editModalMode);
    const needRefresh = useSelector((state) => state.events.needRefresh);
    const modalViewActualTab = useSelector((state) => state.events.modalViewActualTab);
    // Stan dla zdjęcia głównego: { file: File | null, preview: string | null, id: string | null }
    const [mainImage, setMainImage] = useState({ file: null, preview: null, id: null });

    const accessToken = useSelector((state) => state.tokens.accessToken);

    // Stan dla zdjęć dodatkowych: tablica obiektów [{ file: File, preview: string, id: string | null }]
    const [additionalImages, setAdditionalImages] = useState([]);

    const modalViewTabs = [
        "Dane podstawowe",
        "Opis",
        "Multimedia",
    ]

    const [imageHashCode, setImageHashCode] = useState('');
    const [promotionByEventId, setPromotionByEventId] = useState(new Map());

    const MAX_FILE_SIZE = 5242880; // 5MB
    const TICKET_PAID = "P\u0142atny";
    const TICKET_FREE = "Bezp\u0142atny";

    const [formData, setFormData] = useState({
        name: '',
        category: '',
        startDate: '',
        eventTime: '',
        eventEndDate: '',
        eventEndTime: '',
        place: '',
        adres: '',
        city: 'Warszawa',
        ticketInfo: TICKET_FREE,
        ticketPrice: '0',
        description: '',
        zipCode: '',
        added_on_utc: '',
        isActive: true,
        tags: [],
    });
    const [categories, setCategories] = useState([]);
    const [isTagModalOpen, setIsTagModalOpen] = useState(false);
    const [tagInput, setTagInput] = useState('');
    const [isStatusActionLoading, setIsStatusActionLoading] = useState(false);
    const [isPreviewModeEnabled, setIsPreviewModeEnabled] = useState(false);
    const tagInputRef = useRef(null);
    const mainImageInputRef = useRef(null);
    const additionalImagesInputRef = useRef(null);

    const getEventStatusLabel = (eventData) => {
        if (eventData?.hasPendingEdit === true) {
            return 'W trakcie zatwierdzania';
        }

        if (eventData?.isApprovedByAdmin === false) {
            return 'Oczekuj\u0105ce';
        }

        return eventData?.isActive ? 'Aktywne' : 'Nieaktywne';
    };

    const getEventStatusClassName = (eventData) => {
        if (eventData?.hasPendingEdit === true || eventData?.isApprovedByAdmin === false) {
            return 'event-status event-status--pending';
        }

        if (!eventData?.isActive) {
            return 'event-status event-status--inactive';
        }

        return 'event-status event-status--active';
    };

    const fetchCategories = async () => {
        const response = await ApiService.getEventsCategories();
        setCategories(response.data);
    };

    const fetchImages = async (imgId) => {
        try {
            const imgResponse = await fetch(`/api/events-images/${imgId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
                credentials: 'include',
                mode: 'cors'
            });
            if (!imgResponse.ok) {
                throw new Error(`HTTP error! status: ${imgResponse.status}`);
            }
            const blob = await imgResponse.blob();
            // Tworzymy obiekt File, aby spełnić warunki walidacji (mainImage.file)
            // const file = new File([blob], "mainImage.jpg", {type: blob.type});
            const preview = URL.createObjectURL(blob);

            return preview;
        } catch (error) {
            console.error("Błąd pobierania zdjęcia głównego:", error);
        }
    }

    const fetchEvent = async () => {
        const response = await ApiService.getEvent(editedEvent);
        const defaultImage = response.data.image_hash_code;
        const loadedPrice = response.data.ticketPrice ?? '';
        const numericLoadedPrice = Number(loadedPrice);
        const derivedTicketInfo = !Number.isNaN(numericLoadedPrice) && numericLoadedPrice === 0 ? TICKET_FREE : TICKET_PAID;
        console.log(response.data);
        setFormData({
            ...response.data,
            adres: response.data.address ?? response.data.adres ?? '',
            zipCode: response.data.postalCode ?? response.data.zipCode ?? '',
            category: String(response.data.categoryId),
            startDate: response.data.startDate ? response.data.startDate.split('T')[0] : '',
            eventEndDate: response.data.endDate ? response.data.endDate.split('T')[0] : '',
            // Wyciągamy HH:MM (bierzemy 5 pierwszych znaków po 'T')
            eventTime: response.data.startDate && response.data.startDate.includes('T') ? response.data.startDate.split('T')[1].substring(0, 5)  : '',
            eventEndTime: response.data.endDate && response.data.endDate.includes('T') ? response.data.endDate.split('T')[1].substring(0, 5)  : '',
            ticketInfo: derivedTicketInfo,
            tags: Array.isArray(response.data.tags) ? response.data.tags : [],
        });
        setImageHashCode(defaultImage)
        if (defaultImage) {
                const preview = await fetchImages(defaultImage);
                setMainImage({ file: null, preview, id: defaultImage });
        }
    }

    const fetchEventForDuplicate = async (eventId) => {
        const response = await ApiService.getEvent(eventId);
        const defaultImage = response.data.image_hash_code;
        const loadedPrice = response.data.ticketPrice ?? '';
        const numericLoadedPrice = Number(loadedPrice);
        const derivedTicketInfo = !Number.isNaN(numericLoadedPrice) && numericLoadedPrice === 0 ? TICKET_FREE : TICKET_PAID;
        console.log(response.data);
        setFormData({
            ...response.data,
            added_on_utc: '',
            adres: response.data.address ?? response.data.adres ?? '',
            zipCode: response.data.postalCode ?? response.data.zipCode ?? '',
            category: String(response.data.categoryId),
            startDate: '',
            eventEndDate: '',
            // WyciÄ…gamy HH:MM (bierzemy 5 pierwszych znakÃ³w po 'T')
            eventTime: '',
            eventEndTime: '',
            ticketInfo: derivedTicketInfo,
            tags: Array.isArray(response.data.tags) ? response.data.tags : [],
        });
        setImageHashCode(defaultImage || '');
        if (defaultImage) {
            const preview = await fetchImages(defaultImage);
            setMainImage({ file: null, preview, id: defaultImage });
        } else {
            setMainImage({ file: null, preview: null, id: null });
        }
        setAdditionalImages([]);
    }

    const fetchEventPhotos = async () => {
        const response = await ApiService.getAllImagesForEvent(editedEvent);
        console.log(response);
        const images = response.data;
        const loadedImages = [];
        if (images.length > 0) {
            for (const img of images) {

                if (!(imageHashCode === img)) {
                    console.log(img + "  vs  " + imageHashCode);
                    // Pobieramy blob (zakładam, że fetchImages zwraca URL lub blob URL)
                    const preview = await fetchImages(img);

                    // Dodajemy do lokalnej tablicy zamiast od razu do stanu
                    loadedImages.push({file: null, preview: preview, id: img});
                }
            }
        }

        // Aktualizujemy stan TYLKO RAZ, nadpisując wszystko nową listą
        // Dzięki temu unikamy duplikatów i zbędnych przerysowań
        setAdditionalImages(loadedImages);
    };


    useEffect(() => {
        if (!isEditModalOpen) {
            return;
        }

        fetchActiveAndScheduledPromotions().then(setPromotionByEventId);
    }, [isEditModalOpen, editedEvent, needRefresh]);

    useEffect(() => {
        const loadData = async () => {
            await fetchCategories();
            if (isEditModalOpen) {
                await fetchEvent();
                // fetchEventPhotos() będzie się wykonać po fetchEvent()
            }
        };

        loadData();
    }, [isEditModalOpen, editedEvent]);

    useEffect(() => {
        if (isAddModalOpen && duplicatedEventId) {
            fetchCategories();
            fetchEventForDuplicate(duplicatedEventId);
        }
    }, [isAddModalOpen, duplicatedEventId]);

    useEffect(() => {
        if (isAddModalOpen && !isEditModalOpen && !duplicatedEventId) {
            setFormData((prev) => ({
                ...prev,
                eventTime: '',
                eventEndTime: '',
                ticketInfo: TICKET_FREE,
                ticketPrice: "0",
            }));
        }
    }, [isAddModalOpen, isEditModalOpen, duplicatedEventId]);

// Osobny useEffect dla zdjęć dodatkowych
    useEffect(() => {
        if (isEditModalOpen && imageHashCode) {  // ← Czekaj aż imageHashCode się ustawi
            fetchEventPhotos();
        }
    }, [imageHashCode, isEditModalOpen, editedEvent]);


    useEffect(() => {
        const isValid =
            formData.name &&
            formData.category &&
            formData.startDate &&
            formData.eventTime &&
            formData.eventEndDate &&
            formData.eventEndTime &&
            formData.startDate <= formData.eventEndDate &&
            formData.place &&
            formData.city &&
            formData.ticketInfo &&
            (
                formData.ticketInfo === TICKET_FREE ||
                (formData.ticketPrice !== '' && Number(formData.ticketPrice) !== 0)
            ) &&
            formData.description;

        setIsSubmitDisabled(!isValid);
    }, [formData, mainImage, additionalImages]);

    useEffect(() => {
        if (!isEditModalOpen || formData.ticketPrice === '') {
            return;
        }

        const numericPrice = Number(formData.ticketPrice);
        if (Number.isNaN(numericPrice)) {
            return;
        }

        if (numericPrice === 0 && formData.ticketInfo !== TICKET_FREE) {
            setFormData((prev) => ({ ...prev, ticketInfo: TICKET_FREE }));
            return;
        }

        if (numericPrice !== 0 && formData.ticketInfo !== TICKET_PAID) {
            setFormData((prev) => ({ ...prev, ticketInfo: TICKET_PAID }));
        }
    }, [isEditModalOpen, formData.ticketPrice, formData.ticketInfo]);

    useEffect(() => {
        if (isTagModalOpen) {
            setTimeout(() => tagInputRef.current?.focus(), 0);
        }
    }, [isTagModalOpen]);

    // --- NOWA LOGIKA ZDJĘĆ ---
    const defaultPlaceholder = "./x3.jpg";

    const handleDuplikujClick = () => {
        dispatch(setAddEventMode(true));
        dispatch(setModalViewActualTab("Dane podstawowe"));
        dispatch(setDuplicatedEventId(editedEvent));
        dispatch(toggleEditModal());
        dispatch(toggleAddModal());
    }

    const formatDateTime = (value) => {
        if (!value) {
            return '-';
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }
        return date.toLocaleString('pl-PL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const handleOpenStats = () => {
        if (!editedEvent) {
            return;
        }
        dispatch(setSelectedEvent(editedEvent));
        window.location.href = '/statistics';
    };

    // Nowa funkcja do usuwania zdjęcia
    const handleRemoveImage = (indexToRemove) => {
        if (isEditModalOpen && isPreviewModeEnabled) {
            return;
        }
        setAdditionalImages(prev => prev.filter((_, index) => index !== indexToRemove));
        if (isEditModalOpen) {
            const id = additionalImages[indexToRemove].id;
            console.log("usuwam " + id);
            ApiService.deleteEventImage(id);
        }
    };

    // Handler dla wyboru zdjęcia głównego
    const handleMainImageChange = async (source) => {
        if (isEditModalOpen && isPreviewModeEnabled) {
            if (source?.target) {
                source.target.value = "";
            }
            return;
        }
        const file = source?.target ? source.target.files[0] : source;

        if (file && file.size > MAX_FILE_SIZE) {
            alert("Plik jest zbyt duży. Maksymalna wielkość to 5 MB.");
            if (source?.target) {
                source.target.value = ""; // Reset inputa
            }
            return;
        }

        let imageHashCode;
        if (isEditModalOpen) {
            imageHashCode = await ApiService.uploadEventImage(editedEvent, file);
            setImageHashCode(imageHashCode);
            await saveMainImage(imageHashCode);
        }
        if (file) {
            setMainImage({
                file: file,
                preview: URL.createObjectURL(file),
                id: imageHashCode
            });
        }
        if (source?.target) {
            source.target.value = "";
        }
    };

    // Handler dla wyboru wielu zdjęć dodatkowych
    const handleAdditionalImagesChange = async (source) => {
        if (isEditModalOpen && isPreviewModeEnabled) {
            if (source?.target) {
                source.target.value = "";
            }
            return;
        }
        const files = source?.target
            ? Array.from(source.target.files)
            : Array.from(source || []);

        if (files.length > 0) {
            const newImages = [];
            for (const file of files) {
                if (file.size > MAX_FILE_SIZE) {
                    alert(`Plik "${file.name}" jest zbyt duży. Został pominięty. Maksymalna wielkość to 5 MB.`);
                    continue;
                }

                let imageHashCode;
                if (isEditModalOpen) {
                    imageHashCode = await ApiService.uploadEventImage(editedEvent, file);
                }
                newImages.push({
                    file: file,
                    preview: URL.createObjectURL(file),
                    id: imageHashCode
                });
            }
            setAdditionalImages(prev => [...prev, ...newImages]);
        }
        if (source?.target) {
            source.target.value = "";
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, kind) => {
        if (isEditModalOpen && isPreviewModeEnabled) {
            return;
        }
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer?.files || []);
        if (!droppedFiles.length) return;

        if (kind === "main") {
            handleMainImageChange(droppedFiles[0]);
            return;
        }

        handleAdditionalImagesChange(droppedFiles);
    };

    // Funkcja zamieniająca zdjęcie dodatkowe z głównym
    const handleSwapImage = async (indexToSwap) => {
        if (isEditModalOpen && isPreviewModeEnabled) {
            return;
        }
        const imageFromAdditional = additionalImages[indexToSwap];
        const currentMain = mainImage;

        // 1) ZAWSZE aktualizujemy stan lokalny (działa i dla dodawania, i dla edycji)
        setMainImage(imageFromAdditional);

        // 2) Tylko w trybie edycji synchronizujemy backend (mamy już istniejący event + id obrazka)
        if (isEditModalOpen) {
            const newMainHash = imageFromAdditional?.id;

            // Jeśli obrazek pochodzi z pliku i nie ma jeszcze id (hash),
            // to nie ma czego zapisać jako main na backendzie na tym etapie.
            if (newMainHash) {
                setImageHashCode(newMainHash);
                await saveMainImage(newMainHash);
            }
        }

        // 3) Aktualizujemy listę dodatkowych (swap / replace)
        const newAdditionalList = [...additionalImages];

        if (currentMain.file || currentMain.preview) {
            newAdditionalList[indexToSwap] = currentMain;
        } else {
            newAdditionalList.splice(indexToSwap, 1);
        }

        setAdditionalImages(newAdditionalList);
    };
    // -------------------------

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    const handleInputChange = (e) => {
        // Usuwamy st?d logik? walidacji, zostawiamy tylko aktualizacj? stanu
        const { name, value } = e.target;
        setFormData((prev) => {
            if (name === "startDate" && prev.eventEndDate && value && value > prev.eventEndDate) {
                return { ...prev, [name]: value, eventEndDate: "" };
            }

            return { ...prev, [name]: value };
        });
        console.log(formData);
    };

    const handleTicketInfoSelect = (value) => {
        setFormData((prev) => ({
            ...prev,
            ticketInfo: value,
            ticketPrice: value === TICKET_FREE ? "0" : "",
        }));
    };

    const getTimeParts = (value) => {
        const [hour = "00", minute = "00"] = String(value || "00:00").split(":");
        return { hour, minute };
    };

    const handleSplitTimeChange = (field, part, rawValue) => {
        const cleaned = rawValue.replace(/\D/g, "").slice(0, 2);

        setFormData((prev) => {
            const { hour, minute } = getTimeParts(prev[field]);
            const nextHour = part === "hour" ? cleaned : hour;
            const nextMinute = part === "minute" ? cleaned : minute;

            return {
                ...prev,
                [field]: `${nextHour}:${nextMinute}`,
            };
        });
    };

    const handleSplitTimeBlur = (field) => {
        const normalizePart = (value, max) => {
            if (value === "") {
                return "00";
            }
            const parsed = Number.parseInt(value, 10);
            if (Number.isNaN(parsed)) {
                return "00";
            }
            return String(Math.min(parsed, max)).padStart(2, "0");
        };

        setFormData((prev) => {
            const { hour, minute } = getTimeParts(prev[field]);
            const normalizedHour = normalizePart(hour, 23);
            const normalizedMinute = normalizePart(minute, 59);
            return {
                ...prev,
                [field]: `${normalizedHour}:${normalizedMinute}`,
            };
        });
    };

    const handleNextButtonClick = () => {
        const activeTabs = isEditModalOpen
            ? (isPreviewModeEnabled ? previewTabs : editTabs)
            : (addEventMode ? addTabs : modalViewTabs);
        const actual = activeTabs.indexOf(modalViewActualTab);
        if (actual < activeTabs.length - 1) {
            dispatch(setModalViewActualTab(activeTabs[actual + 1]));
        }
    }

    const handlePrevButtonClick = () => {
        const activeTabs = isEditModalOpen
            ? (isPreviewModeEnabled ? previewTabs : editTabs)
            : (addEventMode ? addTabs : modalViewTabs);
        const actual = activeTabs.indexOf(modalViewActualTab);
        if (actual > 0) {
            dispatch(setModalViewActualTab(activeTabs[actual - 1]));
        }
    }

    const handleToggleEventActive = async () => {
        if (!isEditModalOpen || !editedEvent || isStatusActionLoading || isPendingState) {
            return;
        }

        try {
            setIsStatusActionLoading(true);
            const nextActive = !formData.isActive;
            await ApiService.updateEvent(editedEvent, { isActive: nextActive });
            setFormData((prev) => ({ ...prev, isActive: nextActive }));
            dispatch(toggleNeedRefresh());
        } catch (error) {
            console.error('B\u0142\u0105d zmiany statusu wydarzenia:', error);
        } finally {
            setIsStatusActionLoading(false);
        }
    };

    const closeTagModal = () => {
        setIsTagModalOpen(false);
        setTagInput('');
    };

    const handleAddTag = () => {
        const value = tagInput.trim();
        if (!value) {
            return;
        }
        setFormData((prev) => {
            if (prev.tags.includes(value)) {
                return prev;
            }
            return { ...prev, tags: [...prev.tags, value] };
        });
        closeTagModal();
    };

    const handleRemoveTag = (indexToRemove) => {
        setFormData((prev) => ({
            ...prev,
            tags: prev.tags.filter((_, index) => index !== indexToRemove),
        }));
    };

    const activeTabs = isEditModalOpen
        ? (isPreviewModeEnabled ? previewTabs : editTabs)
        : (addEventMode ? addTabs : modalViewTabs);
    const activeTabIndex = activeTabs.indexOf(modalViewActualTab);
    const isLastTab = activeTabIndex === activeTabs.length - 1;
    const isFirstTab = activeTabIndex <= 0;
    const isPendingApproval = formData?.isApprovedByAdmin === false;
    const hasPendingEdit = formData?.hasPendingEdit === true;
    const isPendingState = isPendingApproval || hasPendingEdit;
    const submitDisabled = isSubmitDisabled || (isEditModalOpen && isPendingState);
    const activePreviewTab = previewTabs.includes(modalViewActualTab) ? modalViewActualTab : previewTabs[0];
    const currentResultIndex = visibleEventIds.findIndex((id) => id === editedEvent);
    const currentResultPosition = currentResultIndex >= 0 ? currentResultIndex + 1 : 0;
    const resultsCount = visibleEventIds.length;
    const canGoPrevResult = currentResultIndex > 0;
    const canGoNextResult = currentResultIndex >= 0 && currentResultIndex < resultsCount - 1;
    const addEventStep = modalViewActualTab === "Dane podstawowe" ? 1 : 2;
    const [startHour = "", startMinute = ""] = (formData.eventTime || "").split(":");
    const [endHour = "", endMinute = ""] = (formData.eventEndTime || "").split(":");

    const currentEventPromotion = getPromotionForEvent(promotionByEventId, formData?.id ?? editedEvent);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isEditModalOpen && isPendingState) {
            return;
        }

        try {
            // 2. Przygotowanie danych formularza z IDkami zdjęć
            const data = {
                name: formData.name,
                place: formData.place,
                city: formData.city,
                categoryId: Number(formData.category),
                startDate: `${formData.startDate}T${formData.eventTime}:00`,
                endDate: `${formData.eventEndDate}T${formData.eventEndTime}:00`,
                ticketInfo: formData.ticketInfo,
                ticketPrice: formData.ticketPrice,
                description: formData.description,
                address: formData.adres,
                postalCode: formData.zipCode,
                tags: formData.tags,
                isActive: formData.isActive,
                image_hash_code: imageHashCode,
            };


            let response;
            if (isEditModalOpen) {
                response = await ApiService.updateEvent(editedEvent, data);
                const editedEventName = formData.name || response?.name || editedEvent;
                showAlert(`Zmiany w wydarzeniu ${editedEventName} zosta\u0142y przes\u0142ane do weryfikacji.`);
                dispatch(toggleEditModal());
            }
            if (isAddModalOpen) {
                response = await ApiService.addNewEvent(data);
                const createdEventName = response?.name || formData.name || response?.id || '';
                showAlert(`Twoje wydarzenie ${createdEventName} zosta\u0142o przes\u0142ane do weryfikacji.`);

                // Zapis fotografii dla nowego eventu
                if (response.id) {
                    const eventId = response.id;
                    console.log('Nowe wydarzenie zostało dodane:', eventId);

                    console.log("MainImage " + mainImage.file);

                    // Zapisz główne zdjęcie
                    if (mainImage.file) {
                        const mainHash = await ApiService.uploadEventImage(eventId, mainImage.file);
                        await ApiService.updateEvent(eventId, { image_hash_code: mainHash });
                    }

                    // Zapisz dodatkowe zdjęcia
                    for (const img of additionalImages) {
                        if (img.file) {
                            await ApiService.uploadEventImage(eventId, img.file);
                        }
                    }
                }
                dispatch(toggleAddModal());
            }
            console.log('Wydarzenie zostało dodane/zaktualizowane:', response)
            dispatch(toggleNeedRefresh());
            dispatch(clearDuplicatedEventId());

            // Reset formularza i zdjęć (opcjonalnie)
            setMainImage({ file: null, preview: null, id: null });
            setAdditionalImages([]);

        } catch (error) {
            console.error('Błąd podczas dodawania nowego wydarzenia:', error);
        }
    };

    const saveMainImage = async (imageHashCode) => {

        try {
            // 2. Przygotowanie danych formularza z IDkami zdjęć
            const data = {
                id: editedEvent,
                image_hash_code: imageHashCode
            };

            let response;
            if (isEditModalOpen) {
                response = await ApiService.updateEvent(editedEvent, data);
            }
            console.log('Wydarzenie zostało zaktualizowane:', response)
            dispatch(toggleNeedRefresh());

        } catch (error) {
            console.error('Błąd podczas dodawania nowego wydarzenia:', error);
        }
    };

    const handleCloseModal = () => {
        setIsPreviewModeEnabled(false);
        dispatch(setEditModalMode('preview'));
        if (isAddModalOpen) {
            dispatch(toggleAddModal());
        }
        if (isEditModalOpen) {
            dispatch(toggleEditModal());
        }
        dispatch(clearDuplicatedEventId());
        closeTagModal();
    };

    const handleGoToNeighborEvent = (direction) => {
        if (currentResultIndex < 0) {
            return;
        }
        const nextId = visibleEventIds[currentResultIndex + direction];
        if (!nextId) {
            return;
        }
        dispatch(setEditedEvent(nextId));
        dispatch(setModalViewActualTab("Dane podstawowe"));
    };

    useEffect(() => {
        if (!isEditModalOpen) {
            return;
        }
        setIsPreviewModeEnabled(editModalMode !== 'edit');
    }, [isEditModalOpen, editedEvent, editModalMode]);

    useEffect(() => {
        if (!isEditModalOpen || !isPreviewModeEnabled) {
            return;
        }
        if (!previewTabs.includes(modalViewActualTab)) {
            dispatch(setModalViewActualTab(previewTabs[0]));
        }
    }, [isEditModalOpen, isPreviewModeEnabled, modalViewActualTab, dispatch]);

    return (
        <>
        {isTagModalOpen && (
            <Modal
                isOpen={isTagModalOpen}
                onClose={closeTagModal}
                overlayClassName="modal-overlay-top"
                className="modal-content-small"
            >
                <h2>Dodaj tag</h2>
                <div className="flex-container-space-between border-bottom-light">
                    <label htmlFor="tagInput" className="padding-right-20">Nowy tag</label>
                    <input
                        ref={tagInputRef}
                        autoFocus
                        className=""
                        type="text"
                        id="tagInput"
                        name="tagInput"
                        value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                handleAddTag();
                            }
                        }}
                        title="Wpisz tag"
                    />
                </div>
                <div className="modal-margin-top-20 flex-container-center flex-start text-black">
                    <button className="button-orange-rounded-tiny-textonly text-black" type="button" onClick={closeTagModal}>
                        Anuluj
                    </button>
                    <button className="button-orange-rounded-tiny-textonly text-black" type="button" onClick={handleAddTag}>
                        Dodaj
                    </button>
                </div>
            </Modal>
        )}

        {/* sekcja legacy (bez nowego trybu dodawania) */}
        { !addEventMode && !isEditModalOpen && <Modal isOpen={isAddModalOpen || isEditModalOpen} onClose={handleCloseModal}>
            <h2>{isAddModalOpen ? "Dodaj nowe " : ""} {isEditModalOpen ? "Edytuj ": ""}wydarzenie</h2>
            <div className="userView-menu">
                {
                    modalViewTabs.map((tab, index) => {
                        return (
                            <button
                                type={modalViewActualTab === tab ? "modal-menu-active" : "modal-menu"}
                                id={index}
                                key={index}
                                className={modalViewActualTab === tab ? "buttons-menu-modal-1" : "buttons-menu-modal-2"}
                                onClick= {() => dispatch(setModalViewActualTab(tab))}>{tab}</button>)

                    })
                }
            </div>
            <form onSubmit={handleSubmit}>
                { modalViewActualTab === "Dane podstawowe" &&
                    <>
                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="name" className="padding-right-20">Nazwa wydarzenia</label>
                            <input
                                className="input-field"
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                title="Wprowadź nazwę wydarzenia"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="category" className="padding-right-20">Kategoria wydarzenia</label>
                            <select
                                className="input-field"
                                type="number"
                                id="category"
                                name="category"
                                value={formData.category}
                                title="Wybierz kategorię wydarzenia"
                                onChange={handleInputChange}
                                required
                            >
                                <option value="" disabled>Wybierz z listy</option>
                                { categories.map(category => (
                                    <option key={category.id} value={category.id}>{category.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <div>
                                <label htmlFor="startDate" className="padding-right-20">Data wydarzenia</label>
                                <input
                                    className="input-field"
                                    type="date"
                                    id="startDate"
                                    name="startDate"
                                    value={formData.startDate}
                                    onChange={handleInputChange}
                                    title="Wybierz datę wydarzenia"
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="eventTime" className="padding-right-20">Godzina wydarzenia<span className="required-star">*</span></label>
                                <input
                                    className="input-field"
                                    type="time"
                                    id="eventTime"
                                    name="eventTime"
                                    value={formData.eventTime}
                                    onChange={handleInputChange}
                                    required
                                    title="Wybierz godzinę wydarzenia (np. 10:10)"
                                />
                            </div>
                            <div>
                                <label htmlFor="eventEndDate" className="padding-right-20">Data zakończenia</label>
                                <input
                                    className="input-field"
                                    type="date"
                                    id="eventEndDate"
                                    name="eventEndDate"
                                    value={formData.eventEndDate}
                                    onChange={handleInputChange}
                                    title="Wybierz datę zakończenia wydarzenia"
                                    min={formData.startDate || undefined}
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="eventEndTime" className="padding-right-20">Godzina zakończenia<span className="required-star">*</span></label>
                                <input
                                    className="input-field"
                                    type="time"
                                    id="eventEndTime"
                                    name="eventEndTime"
                                    value={formData.eventEndTime}
                                    onChange={handleInputChange}
                                    required
                                    title="Wybierz godzinę zakończenia (np. 12:30)"
                                />
                            </div>
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="ticketInfo" className="padding-right-20">Bilety</label>
                            <input
                                className="input-field"
                                type="text"
                                id="ticketInfo"
                                name="ticketInfo"
                                value={formData.ticketInfo}
                                onChange={handleInputChange}
                                title="Wpisz informacje o biletach"
                                required
                            />
                        </div>
                        <div className="flex-container border-bottom-light">
                            <label htmlFor="ticketPrice" className="padding-right-20">Cena{formData.ticketInfo === TICKET_PAID && <span className="required-star">*</span>}</label>
                            <input
                                className="input-field"
                                type="number"
                                id="ticketPrice"
                                name="ticketPrice"
                                value={formData.ticketPrice}
                                title="Wprowadź minimalną cenę biletu"
                                onChange={handleInputChange}
                                required={formData.ticketInfo === TICKET_PAID}
                            />
                        </div>
                        <div className="header-group border-bottom">Lokalizacja</div>

                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="place" className="padding-right-20">Nazwa miejsca</label>
                            <input
                                className="input-field"
                                type="text"
                                id="place"
                                name="place"
                                value={formData.place}
                                title="Wprowadź nazwę miejca"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="flex-container-space-between">
                            <label htmlFor="adres" className="padding-right-20">Adres</label>
                            <input
                                className="input-field"
                                type="text"
                                id="adres"
                                name="adres"
                                value={formData.adres}
                                title="Wprowadź adres"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <div>
                                <label htmlFor="zipCode" className="padding-right-20">Kod pocztowy</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="zipCode"
                                    name="zipCode"
                                    value={formData.zipCode}
                                    title="Wprowadź kod pocztowy"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="city" className="padding-right-20">Miejscowość</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="city"
                                    name="city"
                                    value={formData.city}
                                    title="Wprowadź miejscowość"
                                    onChange={handleInputChange}
                                    required
                                    readOnly={true}
                                />
                            </div>
                        </div>
                    </>}

                {modalViewActualTab === "Opis" &&
                    <>
                        <label htmlFor="description">Opis<span className="required-star">*</span></label>
                        <div className="flex-line border-bottom-light" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <textarea
                                type="text"
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                required
                                className="event-description"
                                style={{ flexGrow: 1 }}
                            />
                        </div>
                        <div className="flex-line border-bottom-light add-event-tags-row" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                            <label className="padding-right-20" htmlFor="tagListEdit">Tagi</label>
                            <div id="tagListEdit" className="add-event-tags-list" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', flexGrow: 1 }}>
                                {formData.tags.length > 0 ? (
                                    formData.tags.map((tag, index) => (
                                        <span key={`${tag}-${index}`} style={{ border: '1px solid #ccc', borderRadius: '12px', padding: '2px 8px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                            {tag}
                                            <button
                                                type="button"
                                                className="button-orange-rounded-tiny-textonly"
                                                onClick={() => handleRemoveTag(index)}
                                                title="Usun tag"
                                            >
                                                x
                                            </button>
                                        </span>
                                    ))
                                ) : (
                                    <span>Brak tagow</span>
                                )}
                            </div>
                            <button
                                type="button"
                                className="button-orange-rounded-tiny-plus"
                                onClick={() => setIsTagModalOpen(true)}
                                title="Dodaj tag"
                            >
                                +
                            </button>
                        </div>
                        <p style={{ fontSize: '12px', color: '#666', margin: '6px 0 0 0' }}>
                            {TAGS_HELPER_TEXT}
                        </p>
                    </>}



                {modalViewActualTab === "Multimedia" &&
                    <>
                        <div className="flex-line border-bottom-light">
                            <label htmlFor="mainImageInput" className="padding-right-20">Zdjęcie główne<span className="required-star">*</span></label>
                            <img
                                src={mainImage.preview || defaultPlaceholder}
                                className="imgMiniature"
                                alt="Podgląd głównego zdjęcia"
                            />
                            <input
                                className="input-field"
                                type="file"
                                id="mainImageInput"
                                name="mainImageInput"
                                onChange={handleMainImageChange}
                                title="Wybierz plik obrazka głównego"
                                accept="image/png, image/jpeg, image/webp"
                            />
                        </div>
                        <div className="flex-line border-bottom-light">
                            <label htmlFor="additionalImagesInput" className="padding-right-20">Zdjęcia dodatkowe</label>
                            <input
                                className="input-field"
                                type="file"
                                id="additionalImagesInput"
                                name="additionalImagesInput"
                                onChange={handleAdditionalImagesChange}
                                multiple // Obsługa wielu plików
                                title="Wybierz pliki obrazków dodatkowych"
                                accept="image/png, image/jpeg, image/webp"
                            />
                        </div>
                        <div className="flex-line2 border-bottom-light">
                            {additionalImages.length > 0 ? (
                                additionalImages.map((imgData, index) => (
                                    <div key={index} className="image-container">
                                        <img
                                            src={imgData.preview}
                                            className="imgMiniature"
                                            alt={`Dodatkowe ${index}`}
                                        />

                                        {/* Nakładka widoczna po najechaniu myszką */}
                                        <div className="image-overlay ">
                                            {/* Górna część: Usuń */}
                                            <div
                                                className="overlay-action overlay-action-top  delete"
                                                onClick={() => handleRemoveImage(index)}
                                                title="Usuń to zdjęcie"
                                            >
                                                Usuń
                                            </div>

                                            {/* Dolna część: Ustaw główne */}
                                            <div
                                                className="overlay-action overlay-action-bottom set-main"
                                                onClick={() => handleSwapImage(index)}
                                                title="Ustaw jako zdjęcie główne"
                                            >
                                                Główne
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                // Wyświetlanie placeholderów gdy brak zdjęć dodatkowych
                                <>
                                    {/*<img src={defaultPlaceholder} className="imgMiniature" alt="puste" />*/}
                                </>
                            )}
                        </div>

                    </>
                }

                    <div className="modal-margin-top-20 modal-actions">
                        <div className="modal-actions-left">
                            <button className="button-orange-rounded" type="button" onClick={handleCloseModal}>
                                Anuluj
                            </button>
                            <button className="button-orange-rounded" disabled={isFirstTab} type="button" onClick={handlePrevButtonClick}>
                                <span className="fontX">&larr;&nbsp;</span>Wstecz
                            </button>
                        </div>
                        <div className="modal-actions-right">
                            <button className="button-orange-rounded" disabled={isLastTab} type="button" onClick={handleNextButtonClick}>
                                Dalej<span className="fontX">&nbsp;&rarr;</span>
                            </button>
                            {isEditModalOpen  &&
                            <button className="button-orange-backgrounded" disabled={isLastTab} type="button" onClick={handleDuplikujClick}>
                                Duplikuj
                            </button>}

                            <button type="submit" disabled={submitDisabled} className="button-orange-backgrounded">
                                {/*<span className="fontX">&#8862;&nbsp;</span>*/}
                                <div className="step-box-plus"></div>
                                {isAddModalOpen ? "Dodaj wydarzenie" : ""} {isEditModalOpen ? "Zapisz zmiany": ""}
                            </button>
                        </div>
                    </div>
            </form>
        </Modal> }

        {/*  sekcja dodawania  */}
            { (addEventMode || isEditModalOpen) && <Modal className={`modal-content-add-event ${isEditModalOpen ? "modal-content-add-event-right" : ""} ${isEditModalOpen && isPreviewModeEnabled ? "modal-content-add-event-preview" : ""}`} isOpen={isAddModalOpen || isEditModalOpen} onClose={handleCloseModal}>
                {!isEditModalOpen && (
                    <>
                        <div className="add-event-modal-header">
                            <div className="add-event-modal-title-row">
                                <h2 className="add-event-modal-title">
                                    <span className="add-event-title-icon" aria-hidden="true"></span>
                                    Dodaj wydarzenie
                                </h2>
                            </div>
                        </div>
                        <div className="userView-menu add-event-stepper-shell">
                            <div className="add-event-stepper-visual" role="progressbar" aria-valuemin={1} aria-valuemax={2} aria-valuenow={addEventStep}>
                                <div className="add-event-stepper-item">
                                    <div className="add-event-step-box active">1</div>
                                    <div className="add-event-step-label active">Dane podstawowe</div>
                                </div>
                                <div className="add-event-step-divider">-----</div>
                                <div className="add-event-stepper-item">
                                    <div className={`add-event-step-box ${addEventStep === 2 ? "active" : ""}`}>2</div>
                                    <div className={`add-event-step-label ${addEventStep === 2 ? "active" : ""}`}>Opis i multimedia</div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {isEditModalOpen && isPreviewModeEnabled && (
                    <>
                        <div className="add-event-modal-header add-event-preview-header">
                            <div className="add-event-preview-nav" aria-label="Nawigacja po wynikach">
                                <button
                                    type="button"
                                    className="add-event-preview-nav-btn add-event-preview-nav-btn-up"
                                    onClick={() => handleGoToNeighborEvent(-1)}
                                    disabled={!canGoPrevResult}
                                    title="Poprzedni wynik"
                                >
                                    {">"}
                                </button>
                                <button
                                    type="button"
                                    className="add-event-preview-nav-btn add-event-preview-nav-btn-down"
                                    onClick={() => handleGoToNeighborEvent(1)}
                                    disabled={!canGoNextResult}
                                    title="Następny wynik"
                                >
                                    {">"}
                                </button>
                                <span className="add-event-preview-nav-count">{currentResultPosition} z {resultsCount} wyników</span>
                            </div>
                            <div className="add-event-preview-date">Data dodania: {formatDateTime(formData.added_on_utc)}</div>
                        </div>
                        <div className="add-event-modal-header add-event-preview-title-line">
                            <div className="add-event-modal-title-row">
                                <h2 className="add-event-modal-title">
                                    <span className="add-event-title-icon add-event-title-icon-preview" aria-hidden="true"></span>
                                    Podgląd wydarzenia
                                </h2>
                            </div>
                        </div>
                        <div className="add-event-preview-summary-row">
                            <div className="add-event-preview-summary-left">
                                <div className="add-event-preview-name">{formData.name || "Bez nazwy wydarzenia"}</div>
                                <div className="event-status-group add-event-modal-status-group">
                                    <span className={`${getEventStatusClassName(formData)} add-event-modal-status`}>
                                        {`Wydarzenie ${getEventStatusLabel(formData)}`}
                                    </span>
                                    <EventPromotionBadge promotion={currentEventPromotion} />
                                </div>
                                {hasPendingEdit && formData?.pendingEditRequestedAt && (
                                    <div className="add-event-preview-date">
                                        Zgłoszono: {formatDateTime(formData.pendingEditRequestedAt)}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="userView-menu add-event-preview-tabs">
                            {previewTabs.map((tab, index) => (
                                <button
                                    type="button"
                                    id={index}
                                    key={index}
                                    className={activePreviewTab === tab ? "buttons-menu-modal-1" : "buttons-menu-modal-2"}
                                    onClick={() => dispatch(setModalViewActualTab(tab))}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                    </>
                )}

                {isEditModalOpen && !isPreviewModeEnabled && (
                    <>
                        <div className="add-event-modal-header">
                            <div className="add-event-modal-title-row">
                                <h2 className="add-event-modal-title">
                                    <span className="add-event-title-icon" aria-hidden="true"></span>
                                    Edytuj wydarzenie
                                </h2>
                                <div className="event-status-group add-event-modal-status-group">
                                    <span className={`${getEventStatusClassName(formData)} add-event-modal-status`}>
                                        {`Wydarzenie ${getEventStatusLabel(formData)}`}
                                    </span>
                                    <EventPromotionBadge promotion={currentEventPromotion} />
                                </div>
                                {hasPendingEdit && formData?.pendingEditRequestedAt && (
                                    <div className="add-event-preview-date">
                                        Zgłoszono: {formatDateTime(formData.pendingEditRequestedAt)}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="userView-menu add-event-stepper-shell">
                            <div className="add-event-stepper-visual" role="progressbar" aria-valuemin={1} aria-valuemax={2} aria-valuenow={addEventStep}>
                                <div className="add-event-stepper-item">
                                    <div className="add-event-step-box active">1</div>
                                    <div className="add-event-step-label active">Dane podstawowe</div>
                                </div>
                                <div className="add-event-step-divider">-----</div>
                                <div className="add-event-stepper-item">
                                    <div className={`add-event-step-box ${addEventStep === 2 ? "active" : ""}`}>2</div>
                                    <div className={`add-event-step-label ${addEventStep === 2 ? "active" : ""}`}>Opis i multimedia</div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <form onSubmit={handleSubmit}>
                    <fieldset className={isEditModalOpen && isPreviewModeEnabled ? "add-event-preview-readonly" : ""} disabled={isEditModalOpen && isPreviewModeEnabled}>
                    { modalViewActualTab === "Dane podstawowe" &&
                        <>
                            {!(isEditModalOpen && isPreviewModeEnabled) && (
                            <div className="flex-container-space-between border-bottom-light add-event-form-row">
                                <label htmlFor="name" className="padding-right-20">Nazwa wydarzenia<span className="required-star">*</span></label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    title="Wprowadź nazwę wydarzenia"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            )}
                            <div className="flex-container-space-between border-bottom-light add-event-form-row">
                                <label htmlFor="category" className="padding-right-20">Kategoria wydarzenia<span className="required-star">*</span></label>
                                <select
                                    className="input-field"
                                    type="number"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    title="Wybierz kategorię wydarzenia"
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="" disabled>Wybierz z listy</option>
                                    { categories.map(category => (
                                        <option key={category.id} value={category.id}>{category.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="flex-container-space-between border-bottom-light add-event-form-row add-event-form-row-time">
                                <label htmlFor="startDate" className="padding-right-20">Data rozpoczęcia<span className="required-star">*</span></label>
                                <div className="add-event-date-time-wrap">
                                    <input
                                        className="input-field add-event-date-input"
                                        type="date"
                                        id="startDate"
                                        name="startDate"
                                        value={formData.startDate}
                                        onChange={handleInputChange}
                                        title="Wybierz datę wydarzenia"
                                        required
                                    />
                                    <span className="add-event-time-label">Godzina<span className="required-star">*</span></span>
                                    <div className="add-event-time-split">
                                        <input
                                            className="input-field add-event-time-input"
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={2}
                                            value={startHour}
                                            onChange={(e) => handleSplitTimeChange("eventTime", "hour", e.target.value)}
                                            onFocus={(e) => e.target.select()}
                                            onBlur={() => handleSplitTimeBlur("eventTime")}
                                            title="Godzina (HH)"
                                            required
                                        />
                                        <span className="add-event-time-colon">:</span>
                                        <input
                                            className="input-field add-event-time-input"
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={2}
                                            value={startMinute}
                                            onChange={(e) => handleSplitTimeChange("eventTime", "minute", e.target.value)}
                                            onFocus={(e) => e.target.select()}
                                            onBlur={() => handleSplitTimeBlur("eventTime")}
                                            title="Minuty (MM)"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex-container-space-between border-bottom-light add-event-form-row add-event-form-row-time">
                                <label htmlFor="eventEndDate" className="padding-right-20">Data zakończenia<span className="required-star">*</span></label>
                                <div className="add-event-date-time-wrap">
                                    <input
                                        className="input-field add-event-date-input"
                                        type="date"
                                        id="eventEndDate"
                                        name="eventEndDate"
                                        value={formData.eventEndDate}
                                        onChange={handleInputChange}
                                        title="Wybierz datę zakończenia wydarzenia"
                                        min={formData.startDate || undefined}
                                        required
                                    />
                                    <span className="add-event-time-label">Godzina<span className="required-star">*</span></span>
                                    <div className="add-event-time-split">
                                        <input
                                            className="input-field add-event-time-input"
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={2}
                                            value={endHour}
                                            onChange={(e) => handleSplitTimeChange("eventEndTime", "hour", e.target.value)}
                                            onFocus={(e) => e.target.select()}
                                            onBlur={() => handleSplitTimeBlur("eventEndTime")}
                                            title="Godzina (HH)"
                                            required
                                        />
                                        <span className="add-event-time-colon">:</span>
                                        <input
                                            className="input-field add-event-time-input"
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={2}
                                            value={endMinute}
                                            onChange={(e) => handleSplitTimeChange("eventEndTime", "minute", e.target.value)}
                                            onFocus={(e) => e.target.select()}
                                            onBlur={() => handleSplitTimeBlur("eventEndTime")}
                                            title="Minuty (MM)"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex-container-space-between border-bottom-light add-event-form-row">
                                <label htmlFor="ticketInfo" className="padding-right-20">Wstęp<span className="required-star">*</span></label>
                                <div className="add-event-ticket-controls">
                                    {isEditModalOpen && isPreviewModeEnabled ? (
                                        <div className="input-field add-event-ticket-indicator" aria-label="Wstęp">
                                            {formData.ticketInfo}
                                        </div>
                                    ) : (
                                        <>
                                            <div className="input-field add-event-segmented-control" role="group" aria-label="Wstęp">
                                                <button
                                                    type="button"
                                                    className={`add-event-segment-button ${formData.ticketInfo === TICKET_PAID ? "active" : ""}`}
                                                    onClick={() => handleTicketInfoSelect(TICKET_PAID)}
                                                >
                                                    Płatny
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`add-event-segment-button ${formData.ticketInfo === TICKET_FREE ? "active" : ""}`}
                                                    onClick={() => handleTicketInfoSelect(TICKET_FREE)}
                                                >
                                                    Bezpłatny
                                                </button>
                                            </div>
                                            <input
                                                className="add-event-ticket-hidden"
                                                type="text"
                                                id="ticketInfo"
                                                name="ticketInfo"
                                                value={formData.ticketInfo}
                                                onChange={handleInputChange}
                                                title="Wpisz informacje o biletach"
                                                required
                                                tabIndex={-1}
                                                aria-hidden="true"
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="flex-container border-bottom-light add-event-form-row">
                                <label htmlFor="ticketPrice" className="padding-right-20">Cena{formData.ticketInfo === TICKET_PAID && <span className="required-star">*</span>}</label>
                                <input
                                    className="input-field"
                                    type="number"
                                    id="ticketPrice"
                                    name="ticketPrice"
                                    value={formData.ticketPrice}
                                    title="Wprowadź minimalną cenę biletu"
                                    onChange={handleInputChange}
                                    required={formData.ticketInfo === TICKET_PAID}
                                />
                            </div>
                            <div className="header-group border-bottom">Lokalizacja</div>

                            <div className="flex-container-space-between border-bottom-light add-event-form-row">
                                <label htmlFor="place" className="padding-right-20">Nazwa miejsca<span className="required-star">*</span></label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="place"
                                    name="place"
                                    value={formData.place}
                                    title="Wprowadź nazwę miejca"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="flex-container-space-between border-bottom-light add-event-form-row">
                                <label htmlFor="adres" className="padding-right-20">Adres<span className="required-star">*</span></label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="adres"
                                    name="adres"
                                    value={formData.adres}
                                    title="Wprowadź adres"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="flex-container-space-between border-bottom-light add-event-form-row">
                                    <label htmlFor="zipCode" className="padding-right-20">Kod pocztowy<span className="required-star">*</span></label>
                                    <input
                                        className="input-field"
                                        type="text"
                                        id="zipCode"
                                        name="zipCode"
                                        value={formData.zipCode}
                                        title="Wprowadź kod pocztowy"
                                        onChange={handleInputChange}
                                        required
                                    />
                            </div>
                            <div className="flex-container-space-between border-bottom-light add-event-form-row">
                                    <label htmlFor="city" className="padding-right-20">Miejscowość<span className="required-star">*</span></label>
                                    <input
                                        className="input-field"
                                        type="text"
                                        id="city"
                                        name="city"
                                        value={formData.city}
                                        title="Wprowadź miejscowość"
                                        onChange={handleInputChange}
                                        required
                                        readOnly={true}
                                    />
                            </div>
                        </>}

                    {modalViewActualTab === "Opis" &&
                        <div style={{ position: 'relative' }}>
                            <label className="description-small-padding" htmlFor="description-add">Opis<span className="required-star">*</span></label>
                            <div className="flex-line border-bottom-light" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <textarea
                                    type="text"
                                    id="description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    required
                                    className="event-description-add"
                                    style={{ flexGrow: 1 }}
                                />
                            </div>
                            <div className="flex-line border-bottom-light add-event-tags-row" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                                <label className="padding-right-20" htmlFor="tagList">Tagi</label>
                                <div id="tagList" className="tag-list add-event-tags-list" >
                                    {formData.tags.length > 0 ? (
                                        formData.tags.map((tag, index) => (
                                            <span key={`${tag}-${index}`} className="tag-item">
                                                {tag}
                                                <button
                                                    type="button"
                                                    className="button-orange-rounded-very-tiny-textonly"
                                                    onClick={() => handleRemoveTag(index)}
                                                    title="Usun tag"
                                                >
                                                    x
                                                </button>
                                            </span>
                                        ))
                                    ) : (
                                        <span>Brak tagów</span>
                                    )}
                                </div>
                                <button
                                    type="button"
                                    className="button-orange-rounded-tiny-plus"
                                    onClick={() => setIsTagModalOpen(true)}
                                    title="Dodaj tag"
                                >
                                    +
                                </button>
                            </div>
                            <p style={{ fontSize: '12px', color: '#666', margin: '6px 0 0 0' }}>
                                {TAGS_HELPER_TEXT}
                            </p>
                        </div>}



                    {(
                        (((!isEditModalOpen || !isPreviewModeEnabled) && modalViewActualTab === "Opis")
                        || (isEditModalOpen && isPreviewModeEnabled && modalViewActualTab === "Multimedia"))
                    ) &&
                        <>
                            <div className="flex-line-add-modal add-event-upload-row">
                                <label htmlFor="mainImageInput" className="padding-right-20">Zdjęcie główne<span className="required-star">*</span></label>
                                <input
                                    ref={mainImageInputRef}
                                    className="add-event-hidden-file-input"
                                    type="file"
                                    id="mainImageInput"
                                    name="mainImageInput"
                                    onChange={handleMainImageChange}
                                    title="Wybierz plik obrazka głównego"
                                    accept="image/png, image/jpeg, image/webp"
                                />
                                <div className="add-event-dropzone" onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, "main")}>
                                    <button
                                        type="button"
                                        className="add-event-upload-button"
                                        onClick={() => mainImageInputRef.current?.click()}
                                    >
                                        Dodaj
                                    </button>
                                    <span className="add-event-dropzone-hint">lub przeciagnij i upusc plik tutaj</span>
                                    <span className="add-event-dropzone-note">Zdjęcie powinno mieć format 16x9.</span>
                                </div>
                                <img
                                    src={mainImage.preview || defaultPlaceholder}
                                    className="imgMiniature add-event-main-preview"
                                    alt="Podgląd głównego zdjęcia"
                                />
                            </div>
                            <div className="flex-line-add-modal border-bottom-light add-event-upload-row">
                                <label htmlFor="additionalImagesInput" className="padding-right-20">Zdjęcia dodatkowe</label>
                                <input
                                    ref={additionalImagesInputRef}
                                    className="add-event-hidden-file-input"
                                    type="file"
                                    id="additionalImagesInput"
                                    name="additionalImagesInput"
                                    onChange={handleAdditionalImagesChange}
                                    multiple // Obsługa wielu plików
                                    title="Wybierz pliki obrazków dodatkowych"
                                    accept="image/png, image/jpeg, image/webp"
                                />
                                <div className="add-event-dropzone" onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, "additional")}>
                                    <button
                                        type="button"
                                        className="add-event-upload-button"
                                        onClick={() => additionalImagesInputRef.current?.click()}
                                    >
                                        Dodaj
                                    </button>
                                    <span className="add-event-dropzone-hint">lub przeciagnij i upusc pliki tutaj</span>
                                    <span className="add-event-dropzone-note">Zdjęcie powinno mieć format 16x9.</span>
                                </div>
                            </div>
                            <div className="flex-line2 border-bottom-light">
                                {additionalImages.length > 0 ? (
                                    additionalImages.map((imgData, index) => (
                                        <div key={index} className="image-container">
                                            <img
                                                src={imgData.preview}
                                                className="imgMiniature"
                                                alt={`Dodatkowe ${index}`}
                                            />

                                            {/* Nakładka widoczna po najechaniu myszką */}
                                            <div className="image-overlay ">
                                                {/* Górna część: Usuń */}
                                                <div
                                                    className="overlay-action overlay-action-top  delete"
                                                    onClick={() => handleRemoveImage(index)}
                                                    title="Usuń to zdjęcie"
                                                >
                                                    Usuń
                                                </div>

                                                {/* Dolna część: Ustaw główne */}
                                                <div
                                                    className="overlay-action overlay-action-bottom set-main"
                                                    onClick={() => handleSwapImage(index)}
                                                    title="Ustaw jako zdjęcie główne"
                                                >
                                                    Główne
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    // Wyświetlanie placeholderów gdy brak zdjęć dodatkowych
                                    <>
                                        {/*<img src={defaultPlaceholder} className="imgMiniature" alt="puste" />*/}
                                    </>
                                )}
                            </div>

                        </>
                    }
                    </fieldset>

                <div className="modal-margin-top-20 modal-actions">
                    {isEditModalOpen && isPreviewModeEnabled ? (
                        <div className="add-event-preview-footer-actions">
                            <div className="add-event-preview-footer-left">
                                <button
                                    className="button-orange-backgrounded-tiny"
                                    type="button"
                                    onClick={handleOpenStats}
                                >
                                    Statystyki
                                </button>
                            </div>
                            <div className="add-event-preview-footer-right">
                            <button
                                className="button-orange-rounded-tiny add-event-status-toggle-button"
                                type="button"
                                onClick={handleToggleEventActive}
                                disabled={isStatusActionLoading || isPendingState}
                            >
                                {formData.isActive ? 'Deaktywuj' : 'Aktywuj'}
                            </button>
                            <button className="button-orange-rounded-tiny-textonly add-event-cancel-button" type="button" onClick={handleDuplikujClick}>
                                Duplikuj
                            </button>
                            <button
                                className="button-orange-backgrounded-tiny"
                                type="button"
                                disabled={isPendingState}
                                onClick={() => {
                                    if (modalViewActualTab === "Multimedia") {
                                        dispatch(setModalViewActualTab("Opis"));
                                    }
                                    setIsPreviewModeEnabled(false);
                                }}
                            >
                                Edytuj
                            </button>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="modal-actions-left">
                                <button className="button-orange-rounded-tiny-textonly add-event-cancel-button" type="button" onClick={handleCloseModal}>
                                    Anuluj
                                </button>
                                <button className="button-orange-rounded-tiny add-event-back-button" disabled={isFirstTab} type="button" onClick={handlePrevButtonClick}>
                                    <span className="fontX-tiny">&larr;&nbsp;</span>Wstecz
                                </button>
                            </div>
                            <div className="modal-actions-center">
                                {isEditModalOpen && (
                                    <button
                                        className="button-orange-rounded-tiny add-event-status-toggle-button"
                                        type="button"
                                        onClick={handleToggleEventActive}
                                        disabled={isStatusActionLoading || isPendingState}
                                    >
                                        {formData.isActive ? 'Deaktywuj' : 'Aktywuj'}
                                    </button>
                                )}
                            </div>
                            <div className="modal-actions-right">
                                <button className="button-orange-rounded-tiny add-event-next-button" disabled={isLastTab} type="button" onClick={handleNextButtonClick}>
                                    Dalej<span className="fontX-tiny add-event-next-chevron">&nbsp;&rarr;</span>
                                </button>
                                <button type="submit" disabled={submitDisabled} className="button-orange-backgrounded-tiny">
                                    {/*<span className="fontX-tiny">&#8862;&nbsp;</span>*/}
                                    <div className="step-box-plus"></div> {isAddModalOpen ? "Dodaj wydarzenie" : ""} {isEditModalOpen ? "Zapisz zmiany": ""}
                                </button>
                            </div>
                        </>
                    )}
                </div>
                </form>
            </Modal> }
        </>
    );
}

export default AddEvent;
